import React from 'react';
import NumberFormat from 'react-number-format';
import { Controller } from 'react-hook-form';

const Input = props => {
    const {
        className,
        widthProportion,
        readOnly,
        fixedWidth,
        label,
        labelMobileOnly,
        hintText,
        name,
        placeholder,
        isCurrency,
        isPhone,
        register,
        control,
        ...rest
    } = props;
    let classN = 'inspectletIgnore ';
    classN += className ? className : 'app__editable-input';

    const widthProp = widthProportion ? widthProportion : 'full';
    const readOnlyClass = readOnly ? `${classN}--read-only` : '';

    let style = {};
    if (fixedWidth) {
        style = {
            width: fixedWidth,
        };
    }

    const renderLabel = classN => {
        if (!label) {
            return '';
        }

        if (labelMobileOnly) {
            return <div className={`${classN}__label--mobile`}>{label}</div>;
        }

        return <div className={`${classN}__label`}>{label}</div>;
    };

    const renderHint = () => {
        if (!hintText) {
            return null;
        }

        return <span className="app__hint">{hintText}</span>;
    };

    return (
        <div className={`${classN}`}>
            {renderLabel(classN)}
            <div className="app__editable-input__container-hint">
                {isCurrency && (
                    <Controller
                        control={control}
                        name={name}
                        render={({ field: { onChange, name, value } }) => (
                            <NumberFormat
                                className={`${classN}__input ${widthProp} ${readOnlyClass}`}
                                name={name}
                                style={style}
                                placeholder={placeholder}
                                value={value}
                                prefix={'£'}
                                thousandSeparator={true}
                                onChange={onChange}
                                {...rest}></NumberFormat>
                        )}
                    />
                )}
                {isPhone && (
                    <Controller
                        control={control}
                        name={name}
                        render={({ field: { onChange, name, value } }) => (
                            <NumberFormat
                                className={`${classN}__input ${widthProp} ${readOnlyClass}`}
                                name={name}
                                style={style}
                                placeholder={placeholder}
                                format="##### ### ###"
                                value={value}
                                onChange={onChange}
                                {...rest}></NumberFormat>
                        )}
                    />
                )}
                {!isPhone && !isCurrency && (
                    <input
                        className={`${classN}__input ${widthProp} ${readOnlyClass}`}
                        name={name}
                        style={style}
                        placeholder={placeholder}
                        {...register}
                        {...rest}
                    />
                )}
                {renderHint()}
            </div>
        </div>
    );
};

export default Input;
